<template>
    <div class="digitalHome">
        <div class="swiper">
            <twinSwiper></twinSwiper>
        </div>
        <!-- 数字孪生全生命周期解决方案 -->
        <div class="digital_home_resolve">
            <Title :title="context['解决方案'].title ? context['解决方案'].title : '数字孪生全生命周期解决方案'" 
                   :content="context['解决方案'].content ? context['解决方案'].content : '利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案'"></Title>
            <div class="resolve_container">
                <div class="resolve_item" v-for="(item, index) in context['解决方案'].item" :key="index" :class="'item'+index">
                    <div class="item_header">
                        <div class="image_container">
                            <img :src="item.img" style="width: 70px;" alt="">
                        </div>
                        <p style="color: #fff; font-family: AliMedium; margin-top: 22px;">{{item.title}}</p>
                    </div>
                    <div class="item_content">
                        <p style="color: #c1c1c1; font-size: 0.73rem; ">{{item.content}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- N大行业解决方案 -->
        <div class="digital_home_six">
            <Title :title="context['四大解决方案'].title ? context['四大解决方案'].title : '数字孪生+四大行业解决方案'" 
                   :content="context['四大解决方案'].content ? context['四大解决方案'].content : '矢量利用数字孪生技术，结合行业特点定制行业解决方案，助力企业更安全、更智能'"></Title>
            <div class="six_container">
                <div class="collapse_test">
                    <div class="collapse_left">
                        <el-collapse v-model="collapseValue">
                            <el-collapse-item v-for="(item, index) in context['四大解决方案'].item" :key="index" :name="index" 
                            :title="item.title" @mouseenter.native="handleMouseEnter(index)" @click.native="handleMouseClick(index)">
                                <template slot="title">
                                    <div v-if="collapseValue===(index)" style="display: flex; align-items: center;">
                                        <div style="display: flex; justify-content: center; align-items: center; border-radius: 90%; width: 40px; height: 40px;">
                                            <img :src="selectUnselectImg(index)">
                                        </div>
                                        <span style="font-size: 20px; color: #54d1ef; margin-left: 18px; letter-spacing: 2px; font-weight: 500;">{{ item.title }}</span>
                                    </div>
                                    <div v-else style="display: flex; align-items: center;" >
                                        <div style="display: flex; justify-content: center; align-items: center; border-radius: 90%; width: 40px; height: 40px;">
                                            <img :src="selectSelectImg(index)">
                                        </div>
                                        <span style="font-size: 20px; color: #fff; margin-left: 18px; letter-spacing: 2px; font-weight: 500;">{{ item.title }}</span>
                                    </div>
                                </template>
                                <div class="collapse_item">
                                    <div class="item_left">
                                        <div class="dashed"></div>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_context">
                                            {{ item.content }}
                                        </div>
                                        <div class="item_button">
                                            <img style="cursor: pointer;" src="../../assets/image/30.更多.png" @click="goDigitalDetail(item)">
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div class="collapse_right">
                        <div v-if="collapseValue===0">
                            <img width="100%" src="../../assets/image/3.3智能制造-4.png">
                        </div>
                        <div v-else-if="collapseValue===1">
                            <img width="100%" src="../../assets/image/3.3港口-1.png">
                        </div>
                        <div v-else-if="collapseValue===2">
                            <img width="100%" src="../../assets/image/3.3-能源-2.png">
                        </div>
                        <div v-else>
                            <img width="100%" src="../../assets/image/3.3园区-3.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 发挥着价值 -->
        <div class="digital_home_value">
            <Title :title="context['发挥价值'].title ? context['发挥价值'].title : '它们都在各自行业发挥着价值'" 
                   :content="context['发挥价值'].content ? context['发挥价值'].content : '为品牌及中小型企业提供定制化的行业数字孪生解决方案'"></Title>
            <div class="value_container">
                <div v-for="(item, index) in context['发挥价值'].item"
                    @mouseenter="changeValueHover(true, index)"
                    @mouseleave="changeValueHover(false, index)"
                    :key="index" :class="['item', index===0||index===2 ? 'left_down':'', index===2||index===3 ? 'right_up' : '',
                    ]">
                        <div :class="['inner', valueHover[index]===true ? index === 0 ? 'background' : index === 1 ? 'background1' : index === 2 ? 'background2' : index === 3 ? 'background3' : '' : '']">
                            <img :src="valueHover[index] ? item.iconSelected : item.icon">
                            <p :class="valueHover[index] ? 'title title_color' : 'title'">{{ item.title }}</p>
                            <p :class="valueHover[index] ? 'content content_color' : 'content'">{{ item.content }}</p>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Footer from "../../components/footer/index.vue"
import Header from "../../components/header/index.vue"
import twinSwiper from "../../components/swiperComponent/twinSwiper"
import Title from "../../components/title"
import { getText } from "../../util"
import { fromDictToArray, pushImg } from "../../util/tool"
import { titleHomePage, digitalSolutions, digitalAdvantages, digitalCustomer, successfulProjects, homeValue,  collapseArray} from "../../util/constant"
export default {
    data(){
        return {
            titleHomePage,
            digitalSolutions,
            successfulProjects,
            homeValue,
            centerDialogVisible: false,
            valueHover:[],
            collapseArray,
            collapseValue: 0,
            context: {
                '解决方案': {},
                '四大解决方案': {},
                '发挥价值': {},
            }
        }
    },
    mounted(){
        homeValue.forEach(item=>{
            this.valueHover.push(false)
        })
        let page = '数字孪生+'
        getText(page).then((res) => {
            if(res.code === 200) {
                this.context['解决方案'] = res.data[0]
                this.context['解决方案'].item = fromDictToArray(res.data[0])
                let contextDigital = this.context['解决方案'].item
                this.context['解决方案'].item = pushImg(contextDigital, digitalSolutions)
                this.context['四大解决方案'] = res.data[1]
                this.context['四大解决方案'].item = fromDictToArray(res.data[1])
                this.context['发挥价值'] = res.data[2]
                this.context['发挥价值'].item = fromDictToArray(res.data[2])
                let contextValue = this.context['发挥价值'].item
                this.context['发挥价值'].item = pushImg(contextValue, homeValue)
            }
        })
    },
    methods : {
        initVideo() {
            let myPlayer = this.$video(myVideo, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: "muted",
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                width: 1080,
                height: 600
            });
        },
        playVideo() {
            this.centerDialogVisible = true
            setTimeout(()=>{
                this.initVideo()
            },0)
        },
        selectSelectImg(index){
            if(index === 0){
                return require('../../assets/image/资源 272.png')
            }else if(index === 1){
                return require('../../assets/image/资源 273.png')
            }else if(index === 2){
                return require('../../assets/image/资源 277.png')
            }else if(index === 3){
                return require('../../assets/image/资源 274.png')
            }
        },
        selectUnselectImg(index){
            if(index === 0){
                return require('../../assets/image/资源 265.png')
            }else if(index === 1){
                return require('../../assets/image/资源 262.png')
            }else if(index === 2){
                return require('../../assets/image/资源 264.png')
            }else if(index === 3){
                return require('../../assets/image/资源 260.png')
            }
        },
        handleChange(value){
            this.collapseValue = value
        },
        goDigitalDetail(item){
           let to = item.title
           if(to.includes('智能制造')){
               this.$router.push({path: '/create'})
           }else if(to.includes('园区')){
               this.$router.push({path: '/factory'})
           }else if(to.includes('港口')){
               this.$router.push({path: '/dock'})
           }else if(to.includes('能源')){
               this.$router.push({path: '/energy'})
           }
        },
        changeValueHover(boolean, index){
            this.$set(this.valueHover, index, boolean)
        },
        handleMouseClick(id){
            if(this.collapseValue !== id) this.collapseValue = id
        },
        handleMouseEnter(id) {
            console.log(id, this.collapseValue);
            this.collapseValue = id // 设置当前移入项为展开状态
        },
    },
    components: {
        Footer,
        Header,
        twinSwiper,
        Title,
    }
}
</script>

<style scoped lang="less">
.digitalHome{
    .digital_home_resolve{
        margin: 0 auto;
        // height: 600px;
        width: 100%;
        background-color: #1e1d1d;
        padding: 5rem 0;
        .resolve_container{
            display: flex;
            justify-content: space-between;
            width: 70%;
            margin: 5rem auto 2rem;
            .resolve_item{
                width: 23.5%;
                aspect-ratio: 0.77 / 1;
                // background-color: chocolate;
                border-radius: 4px;
                background-size: cover;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                .item_header{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    height: 45%;
                }
                .image_container{
                    // margin: 10% 0 10% 0;
                }
                .item_content{
                    height: 51%;
                    background-color: rgba(0, 0, 0, 0.354);
                    padding:10% 10%;
                    // font-size: 0.75rem;
                    // letter-spacing: 0.1rem;
                    overflow: hidden;
                    line-height: 1.38rem;
                    border-bottom-left-radius: 7px;
                    border-bottom-right-radius: 7px;
                }
            }
            .item0{
                background-image: url("../../assets/image/资源\ 29.png");
            }
            .item1{
                background-image: url("../../assets/image/资源\ 28.png");
            }
            .item2{
                background-image: url("../../assets/image/资源\ 27.png");
            }
            .item3{
                background-image: url("../../assets/image/资源\ 26.png");
            }
        }
    }
    .digital_home_six{
        background-color: #000;
        padding: 5rem 0 0 0;
        .collapse_test{
            width: 60%;
            min-height: 400px;
            display: flex;
            margin: 5rem auto 0;
            padding-bottom: 7rem;
            .collapse_left{
                width: 50%;
                .collapse_item{
                    display: flex;
                    padding-top: 6px;
                    .item_left{
                        height: auto;
                        // background-color: #ff0000;
                        width: 8%;
                        display: flex;
                        justify-content: center;
                        .dashed{
                            width: 20px;
                            height: 200px; /* 虚线的高度 */
                            border-right: 2px dashed ; /* 使用虚线样式，并设置为透明 */
                            // background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.5)); /* 设置背景渐变，从白色透明度百分之百到百分之50 */
                            // background-image: repeating-linear-gradient(to bottom, white, rgb(131, 131, 131) 5px, #000000 5px, #000000 10px); /* 间隔为5px */
                        }
                    }
                    .item_right{
                        height: auto;
                        padding: 5px 6px 1rem 42px;
                        line-height: 2;
                        letter-spacing: 1px;
                        .item_context{
                            padding: 1rem 6rem 1rem 0;
                            font-size: 12px;
                            color: #868686;
                            line-height: 2;
                            letter-spacing: 2px;
                        }
                    }
                }
            }
            .collapse_right{
                width: 50%;
            }
        }
    }
    .digital_home_value{
        background-color: #1f1f1f;
        padding: 5rem 0;
        .value_container{
            width: 65%;
            display: flex;
            flex-wrap: wrap;
            margin: 0 auto;
                // width: 90%;
                // height: 90%;
                .item{
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 10px;
                    .inner{
                        width: 100%;
                        /* height: 95%; */
                        margin: 0 auto;
                        padding: 5rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
                    .title:hover{
                        color: #54d1ef;
                    }
                    .title{
                        color: #fff;
                        padding: 2rem 0 1rem;
                    }
                    .title_color{
                        color: #54d1ef;
                    }
                    .content{
                        color: #717171;
                        font-size: 0.8rem;
                    }
                    .content_color{
                        color: #fff;
                    }
                }
                .left_down{
                    // background-color: chocolate;
                    border-right: 1px solid #e5e5e5;
                    // border-bottom: 1px solid #e5e5e5;
                }
                .right_up{
                    // border-left: 1px solid #e5e5e5;
                    border-top: 1px solid #e5e5e5;
                }
                .background{
                    background-image: url('../../assets/image/资源 507-8.png');
                    background-size: cover;
                }
                .background1{
                    background-image: url('../../assets/image/资源 504-8.png');
                    background-size: cover;
                }
                .background2{
                    background-image: url('../../assets/image/资源 505-8.png');
                    background-size: cover;
                }
                .background3{
                    background-image: url('../../assets/image/资源 506-8.png');
                    background-size: cover;
                }
        }
    }
    .digital_home_video{
        width: 100%;
        background-color: #1e1d1d;
        .video_container{
            margin: 0 auto;
            height: 500px;
            width: 70%;
            position: relative;
            background-size: cover;
            .video_dialog{
                height: 20%;
                width: 80%;
                left: 10%;
                background-color: #00000095;
                position: absolute;
                bottom: 0;
                display: flex;
                .dialog_left{
                    width: 40%;
                    margin: auto;
                    p{
                        color: rgb(255, 255, 255);
                        font-size: 1.2rem;
                        letter-spacing: 1px;
                        padding-bottom: 2%;
                    }
                }
                .dialog_right{
                    width: 52%;
                    display: flex;
                    align-items: center;
                    p{
                        color: rgb(151 151 151);
                        font-size: 0.75rem;
                        line-height: 1.7;
                        letter-spacing: 0.5px;
                        border-left: 1px solid rgb(151 151 151);
                        padding-left: 5%;
                    }
                }
            }
        }
    }
}
::v-deep .el-dialog{
    background-color: #defade;
    opacity: 0.9;
    display: flex;
    justify-content: center;
}
::v-deep .el-collapse{
    border: none;
}
::v-deep .el-collapse-item__content{
    padding: 0;
}
::v-deep .el-collapse-item__arrow{
    display: none;
}
::v-deep .el-collapse-item__header{
    background-color: #000;
    border: none;
    height: 53px;
    line-height: 53px;
}
::v-deep .el-collapse-item__wrap{
    background-color: #000;
    border: none;
}
</style>